import { listStates } from "@/components/staticFiles/stateLookup.js";
import { listmonths } from "@/components/staticFiles/months.js";

// function updates sfg.json array depend on selected dropdown values
export function filterCards(state, month, card, cards) {
  let stateval =
    state == "Select a State"
      ? "SCA"
      : listStates.find(({ desc }) => desc == state).value;
  let monthval =
    month == "Any Month"
      ? 9
      : listmonths.find(({ desc }) => desc == month).value;
  // let plural = cards.find( ({ plural }) => plural == true ) ? 'Are' : 'Is'

  // 1. -state -month +veg
  if (
    (state == "Select a State" || state == "" || state == null) &&
    (month == "Any Month" || month == "" || month == null) &&
    card !== "Any Produce" &&
    card !== "" &&
    card !== null
  ) {
    this.msg =
      "Produce Available in the U.S. During Different Months of the Year";
    return [cards.find(({ name }) => name == card)];

    // 2. +state -month -veg
  } else if (
    state !== "Select a State" &&
    state !== "" &&
    state !== null &&
    (month == "Any Month" || month == "" || month == null) &&
    (card == "Any Produce" || card == "" || card == null)
  ) {
    this.msg =
      "Produce Available in " + state + " During Different Months of the Year";
    return cards.filter((item) => item.states[stateval]);

    // 3. +state/-state +month -veg
  } else if (
    state !== "Select a State" &&
    state !== "" &&
    state !== null &&
    month !== "Any Month" &&
    month !== "" &&
    month !== null &&
    (card == "Any Produce" || card == "" || card == null)
  ) {
    this.msg = "Produce Available in " + state + " in " + month;
    return cards
      .filter((item) => item.states[stateval])
      .filter((item) =>
        item.states[stateval].seasons.find((item) => item == monthval)
      );

    // 4. +state -month +veg
  } else if (
    state !== "Select a State" &&
    state !== "" &&
    state !== null &&
    (month == "Any Month" || month == "" || month == null) &&
    card !== "Any Produce" &&
    card !== "" &&
    card !== null
  ) {
    if (cards.find(({ name }) => name == card).states[stateval]) {
      this.msg =
        "Produce Available in " +
        state +
        " During Different Months of the Year";
      return [cards.find(({ name }) => name == card)];
    } else {
      this.msg =
        card +
        " Are Not Grown in " +
        state +
        "\n\nProduce Available in " +
        state +
        " During Different Months of the Year";
      return cards.filter((item) => item.states[stateval]);
    }

    // 5. +state/-state +month +veg
  } else if (
    state !== "Select a State" &&
    state !== "" &&
    state !== null &&
    month !== "Any Month" &&
    month !== "" &&
    month !== null &&
    card !== "Any Produce" &&
    card !== "" &&
    card !== null
  ) {
    if (cards.find(({ name }) => name == card).states[stateval]) {
      if (
        cards
          .find(({ name }) => name == card)
          .states[stateval].seasons.find((item) => item == monthval)
      ) {
        this.msg = "Produce Available in " + state + " in " + month;
        return [cards.find(({ name }) => name == card)];
      } else {
        this.msg =
          card +
          " Are Not Grown in " +
          state +
          " in " +
          month +
          "\n\nProduce Available in " +
          state +
          " in " +
          month;
        // return [cards,msg]
        return cards
          .filter((item) => item.states[stateval])
          .filter((item) =>
            item.states[stateval].seasons.find((item) => item == monthval)
          );
      }
    } else {
      this.msg =
        card +
        " Are Not Grown in " +
        state +
        "\n\nProduce Available in " +
        state +
        " in " +
        month;
      return cards
        .filter((item) => item.states[stateval])
        .filter((item) =>
          item.states[stateval].seasons.find((item) => item == monthval)
        );
    }
  } else {
    this.msg =
      "Produce Available in the U.S. During Different Months of the Year";
    return cards;
  }
}
